/**
 * Entry point for a standalone Password input used within a Blade page.
 */

import { mountVueComponent } from '@client/core/bootstrap/mount-vue-component';
import PasswordInput from '@client/components/form/PasswordInput.vue';

mountVueComponent(PasswordInput, {
  name: 'PhotoLogApp',
  mount: '#password-input-mount',
});
